import type { SupportedLocale } from "../lib/localization";

interface LanguageSwitcherProps {
  locale: SupportedLocale;
  onChange: (locale: SupportedLocale) => void;
  className?: string;
}

export function LanguageSwitcher({ locale, onChange, className = "" }: LanguageSwitcherProps) {
  return (
    <div
      role="group"
      aria-label="Language"
      className={`inline-flex items-center gap-2 text-xs ${className}`}
    >
      <button
        type="button"
        onClick={() => onChange("es")}
        aria-pressed={locale === "es"}
        className={locale === "es" ? "text-current" : "text-current/40 hover:text-current"}
      >
        ES
      </button>
      <span className="text-current/20">/</span>
      <button
        type="button"
        onClick={() => onChange("en")}
        aria-pressed={locale === "en"}
        className={locale === "en" ? "text-current" : "text-current/40 hover:text-current"}
      >
        EN
      </button>
    </div>
  );
}
